/* global debounce */
if (!customElements.get('cart-note')) {
  class CartNote extends HTMLElement {
    constructor() {
      super();
      this.disclosure = this.closest('details');

      if (this.disclosure && this.disclosure.matches('.cart-note-disclosure')) {
        this.cartNoteToggle = this.disclosure.querySelector('.js-show-note');
      }

      this.fetchRequestOpts = {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      };

      this.init();
    }

    init() {
      this.debouncedHandleNoteChange = debounce(this.handleNoteChange.bind(this), 300);
      // Save as soon as possible, avoid link-click not providing time to save
      this.debouncedHandleAttributeChange = debounce(this.handleAttributeChange.bind(this), 300);
      this.addEventListener('input', (evt) => {
        if (evt.target.name === 'note') {
          this.debouncedHandleNoteChange(evt);
        } else if (evt.target.name && evt.target.name.startsWith('attributes[')) {
          this.debouncedHandleAttributeChange(evt);
        }
      });
    }

    handleNoteChange(evt) {
      if (this.cartNoteToggle) {
        const label = evt.target.value ? theme.strings.editCartNote : theme.strings.addCartNote;
        if (this.cartNoteToggle.textContent !== label) this.cartNoteToggle.textContent = label;
      }

      this.fetchRequestOpts.body = JSON.stringify({ note: evt.target.value });
      fetch(theme.routes.cartUpdate, this.fetchRequestOpts);
    }

    handleAttributeChange(evt) {
      const attributeKey = evt.target.name.match(/attributes\[(.*?)\]/)[1];
      const attributeData = {
        attributes: {
          [attributeKey]: evt.target.value
        }
      };

      this.fetchRequestOpts.body = JSON.stringify(attributeData);
      fetch(theme.routes.cartUpdate, this.fetchRequestOpts);
    }
  }

  customElements.define('cart-note', CartNote);
}
